import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@material-ui/core";
import React, {useState} from "react";
import {SaveButton, Toolbar, useRedirect} from "react-admin";
import {Spacer} from "../../../components/spacer";

export const CustomToolbar = props => {
  const [showConfirm, setShowConfirm] = useState(false)
  const redirect = useRedirect()
  return (
    <Toolbar {...props} style={{display: 'flex', justifyContent: 'space-between'}}>
      <SaveButton handleSubmitWithRedirect={() => setShowConfirm(true)} />
      <Button
        onClick={() => redirect('/formsAvailability')}
        type={'button'}
      >
        Cancelar
      </Button>
      {
        showConfirm && (
          <ConfirmationDialog
            onConfirm={() => props.handleSubmitWithRedirect('edit')}
            onClose={() => setShowConfirm(false)}
            open
          />
        )
      }
    </Toolbar>
  )
};


const ConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
}) => (
  <Dialog open={open} onClose={onClose} fullWidth>
    <DialogTitle> Confirma esta operação ? </DialogTitle>
    <DialogContent dividers>
      <DialogContentText>
        Ao salvar o formulário fará com que esteja visível e disponível para os alunos no período informado.
        Certifique-se que todas as informações estão corretas antes de prosseguir
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button variant='contained' onClick={onClose}>Cancelar</Button>
      <Spacer />
      <Button variant='contained' onClick={onConfirm}>Confirmar</Button>
    </DialogActions >
  </Dialog >
)
